import React from "react";
import { Tooltip, IconButton } from "@mui/material";

const ToolTip = ({ title, color="rgb(0,40,85)"}) => {

 
  return (
    <span>
      <Tooltip
        title={title}
        componentsProps={{
          tooltip: {
            sx: {
              color: "#fff",
              backgroundColor: "rgb(0,40,85)",
              borderRadius: 0,
              maxWidth: "200px",
              padding: "10px",
              fontSize: "13px",
            },
          },
          arrow: {
            sx: {
              color: "rgb(0,40,85)",
            },
          },
        }}
        arrow
        placement="left-start"
      >
        <IconButton>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="18"
            height="18"
            viewBox="0 0 16 16"
          >
            <path
              fill={color}
              d="M7.5 0.5A7 7 0 1 0 7.5 14.5A7 7 0 1 0 7.5 0.5Z"
            ></path>
            <path
              fill={color}
              d="M7.5,1C11.084,1,14,3.916,14,7.5S11.084,14,7.5,14S1,11.084,1,7.5S3.916,1,7.5,1 M7.5,0 C3.358,0,0,3.358,0,7.5S3.358,15,7.5,15S15,11.642,15,7.5S11.642,0,7.5,0L7.5,0z"
            ></path>
            <path
              fill="#fff"
              d="M7.5 3.83A.67.67 0 1 0 7.5 5.17.67.67 0 1 0 7.5 3.83zM8 10L8 6 6.329 6 6.329 7 7 7 7 10 6 10 6 11 9 11 9 10z"
            ></path>
          </svg>
        </IconButton>
      </Tooltip>
    </span>
  );
};

export default ToolTip;
